import * as React from "react"

import { cn } from "@/lib/utils"

const DATE_TYPES = new Set(["date", "time", "datetime-local", "month", "week"]);

const Input = React.forwardRef(({ className, type, autoComplete, ...props }, ref) => {
  // Safari aggressively autofills date inputs (birthday from Contacts, etc.) so
  // it can look like the field is pre-filled. Default autocomplete to "off" for
  // date/time inputs unless the caller explicitly opts in.
  const resolvedAutoComplete =
    autoComplete ?? (DATE_TYPES.has(type) ? "off" : undefined);
  return (
    <input
      type={type}
      autoComplete={resolvedAutoComplete}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
